import { render, staticRenderFns } from "./BrandVideo.vue?vue&type=template&id=97a26d20&scoped=true&"
import script from "./BrandVideo.vue?vue&type=script&lang=ts&"
export * from "./BrandVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandVideo.vue?vue&type=style&index=0&id=97a26d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a26d20",
  null
  
)

export default component.exports